import { useEffect } from 'react';
import AvailabilityCollectionSettings from 'components/AppService/ExamV3Settings/AvailabilityCollectionSettings/AvailabilityCollectionSettings';
import { fetchReservationModes } from 'slices/reservationMode.slice';
import { fetchReservationTemplates } from 'slices/reservationTemplate.slice';
import { useAppDispatch } from 'slices/store';
import { DefaultContentLayout } from '@timeedit/ui-components';

const AvailabilityCollectionSettingsPage = () => {
  const dispatch = useAppDispatch();
  useEffect(() => {
    dispatch(fetchReservationModes());
    dispatch(fetchReservationTemplates());
  }, []);

  return (
    <DefaultContentLayout
      title="Availability collection settings"
      subtitle="Availability collection rule settings for invigilators"
    >
      <div className="inner-content--wrapper allow-scroll">
        <AvailabilityCollectionSettings />
      </div>
    </DefaultContentLayout>
  );
};

export default AvailabilityCollectionSettingsPage;
